import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const PriceTypePages = {
  list: 'ListPriceType',
  add: 'AddPriceType',
  edit: 'EditPriceType',
}

const title = t('entities.priceType')
const path = '/price-types'
const breadcrumb = [{ title, path }]

const priceTypeFormComponent = () =>
  import('@/pages/mainPageWithRoute/price-type/FormPriceType.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: PriceTypePages.add,
  component: priceTypeFormComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: PriceTypePages.edit,
  component: priceTypeFormComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: PriceTypePages.list,
  component: () => import('@/pages/mainPageWithRoute/price-type/ListPriceTypePage.vue'),
  meta: { title, requiresAuth: true },
}

export const PriceTypes: RouteRecordRaw = {
  path,
  name: 'priceTypes',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
